import { Slot } from "radix-ui";
import * as React from "react";
import { type VariantProps } from "tailwind-variants";

import { cn } from "@/lib/utils";

import { buttonVariants } from "./variants";

type ButtonVariants = VariantProps<typeof buttonVariants>;

interface ButtonProps extends React.ComponentProps<"button">, ButtonVariants {
  children: React.ReactNode;
  asChild?: boolean;
}

const Button = ({
  className,
  variant,
  size,
  asChild = false,
  ...props
}: ButtonProps) => {
  const Comp = asChild ? Slot.Root : "button";
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  );
};

export { Button };
